import React, { useCallback, useEffect, useState } from 'react';
import { Loader2, Link2, Inbox } from 'lucide-react';
import { api } from '../../context/AuthContext';
import { ZuordnenDialog } from './ZuordnenDialog';

const fmt = (iso) => { if (!iso) return '—'; try { return new Date(iso).toLocaleDateString('de-DE'); } catch { return iso; } };
const GRUND = { unbekannt: 'Kein Mandant gefunden', mehrdeutig: 'Mehrere Mandanten möglich' };

export const OffenListe = ({ onCount }) => {
  const [items, setItems] = useState(null);
  const [area, setArea] = useState('');
  const [edit, setEdit] = useState(null);

  const load = useCallback(() => api.get('/register/offen').then((r) => { setItems(r.data.items || []); onCount?.(r.data.total); }), [onCount]);
  useEffect(() => { load(); }, [load]);

  if (!items) return <div className="flex justify-center py-16"><Loader2 className="w-5 h-5 animate-spin text-[#b8893d]" /></div>;
  const areas = [...new Set(items.map((i) => i.area_label))];
  const shown = area ? items.filter((i) => i.area_label === area) : items;

  return (
    <div data-testid="offen-liste">
      <div className="flex flex-wrap items-center gap-1.5 mb-4">
        {['', ...areas].map((a) => (
          <button key={a || 'all'} type="button" onClick={() => setArea(a)} data-testid={`offen-filter-${a || 'all'}`}
            className={`px-3 py-1 text-[11px] rounded-full border ${area === a ? 'bg-[#1B3A5C] border-[#1B3A5C] text-white' : 'bg-white border-gray-200 text-[#1B3A5C]'}`}>
            {a || 'Alle Bereiche'} ({a ? items.filter((i) => i.area_label === a).length : items.length})
          </button>
        ))}
      </div>
      {shown.length === 0 ? (
        <div className="text-center py-16 text-sm text-[#7a8a99]" data-testid="offen-leer"><Inbox className="w-8 h-8 mx-auto mb-2 text-[#b8893d]" /> Alles ist einem Mandanten zugeordnet.</div>
      ) : (
        <div className="bg-white border border-gray-200 divide-y divide-gray-100">
          {shown.map((it) => (
            <div key={`${it.area}-${it.id}`} className="flex flex-wrap items-center gap-3 px-4 py-2.5 text-xs" data-testid={`offen-item-${it.id}`}>
              <span className="text-[10px] tracking-wider text-[#b8893d] w-28 flex-shrink-0">{it.area_label.toUpperCase()}</span>
              <div className="flex-1 min-w-[200px]">
                <p className="text-[#1B3A5C] font-medium truncate">{it.titel}</p>
                <p className="text-[#7a8a99] truncate">{it.name || '—'} · {it.email || 'keine E-Mail'}{it.angabe_mnr ? ` · M-Nr. ${it.angabe_mnr}` : ''}{it.angabe_az ? ` · ${it.angabe_az}` : ''}</p>
              </div>
              <span className="text-[10px] text-amber-700">{GRUND[it.zuordnung?.grund] || 'offen'}{it.zuordnung?.kandidaten?.length ? `: ${it.zuordnung.kandidaten.join(', ')}` : ''}</span>
              <span className="text-[10px] text-[#7a8a99] w-20 text-right">{fmt(it.datum)}</span>
              <button type="button" onClick={() => setEdit(it)} data-testid={`offen-zuordnen-${it.id}`}
                className="inline-flex items-center gap-1 px-3 py-1.5 text-[10px] tracking-wider border border-[#1B3A5C] text-[#1B3A5C] hover:bg-[#1B3A5C] hover:text-white transition-colors"><Link2 className="w-3 h-3" /> ZUORDNEN</button>
            </div>
          ))}
        </div>
      )}
      {edit && <ZuordnenDialog item={edit} onClose={() => setEdit(null)} onDone={() => { setEdit(null); load(); }} />}
    </div>
  );
};

export default OffenListe;
